














import { Vue, Component, Prop } from 'vue-property-decorator';

import ConfirmationModal from '../ConfirmationModal/ConfirmationModal.vue';

import OffersService from '@/api/OffersService';

import eventBus from '@/utils/eventBus';

@Component({
  components: {
    ConfirmationModal
  }
})
export default class ArchiveOfferModal extends Vue {
  @Prop(String) offerId!: string;
  @Prop() onArchiveOfferConfirm!: (isSuccess: boolean) => void;

  offerService = new OffersService();
  loading = false;

  onClose() {
    eventBus.$emit('closeModal');
  }

  async handleArchiveOffer() {
    try {
      this.loading = true;

      await this.offerService.changeOfferStatus(this.offerId, 'archived');

      this.onArchiveOfferConfirm(true);
    } catch {
      this.onArchiveOfferConfirm(false);
    } finally {
      this.loading = false;
      this.onClose();
    }
  }
}
